export default __webpack_public_path__ + "static/media/13.9f7a2bed.png";